import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket;

  constructor() {
    var accessToken = sessionStorage.getItem('accessToken');

    this.socket = io(environment.reportApiUrl, {
      extraHeaders: {
        Authorization: 'Bearer ' + accessToken,
      },
    });
  }

  // Listen to events
  listen(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }

  // Emit events
  emit(eventName: string, data: any) {
    this.socket.emit(eventName, data);
  }

  // Disconnect the socket when done
  disconnect() {
    this.socket.disconnect();
  }
}
